<style scoped>
.svgContent {
  width: 100%;
  text-align: center;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);

  -webkit-transform: translate3d(0,0,0);
  -moz-transform: translate3d(0,0,0);
  -ms-transform: translate3d(0,0,0);
  -o-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);

  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  -webkit-perspective:1000;
  perspective:1000;

  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.svgTitle{
  position: fixed;
  width: 100%;
  top: 5px;
  z-index: 999;
}
.svgTitle-content{
  background-color: white;
  width: 70px;
  margin: 0 auto;
}
.svgTitle-close{
  float: right;
  margin-top: 3px;
  margin-right: 3px;
}
.svg-playPause{
  position: fixed;
  top: 40%;
  left: 45%;
  z-index: 999;
}
.svg-icon{
  color: black;
  font-size: 60px;
  opacity: 0.2;
}
.lineOpen{
  position: fixed;
  outline: 0;
  width: 95%;
  margin-left: 10px;
  top: 38px;
  color: white;
  background-color: rgba(0,0,0,.4);
  border: 0;
  border-radius: 6px;
  background-clip: padding-box;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  padding: 5px;
  z-index: 999;
}
.svgFooter{
  position: fixed;
  bottom: 0px;
  width: 100%;
}
</style>

<template>
    <div>
        <header v-title data-title="地铁线路图"/>

        <div class="svgTitle">
          <h2 class="svgTitle-content">{{cityName}}</h2>
        </div>

        <div class="svg-playPause" @click="handleClickIcon">
          <Icon :type="beginPlay?'md-pause':'md-play'" class="svg-icon"/>
        </div>

        <div v-show="playIndex > -1 && showPlayContent"  class="lineOpen">
          <b v-if="showPlayContent">{{stationOpenStatistic[playIndex].openDate}}： {{showTimeContent}}</b>

          <label class="svgTitle-close" @click="handleCloseTitle">
            <van-icon name="cross"/>
          </label>
          <!-- 显示线路描述和投放历史 -->
          <LineInfo ref="lineInfo" :beginPlay="beginPlay" :cityCode="chooseCity" :allLines="allLines"
            @on-demand-stations="handleShowDemandStations"/>
        </div>

        <div v-html="svgHtml" id="svgWorkPlatform" class="svgContent"></div>

        <van-row class="svgFooter">
          <van-col span="12">
            <van-button size="large" icon="md-git-commit" type="default" @click="handleLineSearch">选择线路</van-button>
            <!-- 背景音乐 -->
            <audio :src="bgsround" controls="controls" loop preload id="music1" hidden></audio>
          </van-col>
          <van-col span="12">
            <van-button size="large" type="default" icon="bars" @click="showCitys=true">切换城市</van-button>
          </van-col>
        </van-row>

        <van-popup v-model="showCitys" position="right" round  :style="{ height: '100%', width:'50%' }">
          <van-index-bar :index-list="cityGroup">
            <template v-for="(group,index) in cityGroup">
              <van-index-anchor :key="index" :index="group">
                <span class="remark">{{group}}</span>
              </van-index-anchor>
              <van-cell v-for="city in citys.filter(x=>x.group === group)" :title="city.name" :key="city.code" @click="handleChangeCity(city)"/>
            </template>
          </van-index-bar>
        </van-popup>

        <van-popup v-model="showLines" position="bottom" :style="{ height: '30%' }" >
          <van-picker title="请选择查询线路" show-toolbar :default-index="defalutChooseLine"
            :columns="lineColumns" @confirm="handleChooseLine" @cancel="handleCancelLine"/>
          <br/>
        </van-popup>

    </div>
</template>

<script>
import '@vant/touch-emulator' // 用于解决web端模拟移动端的触摸事件
import LineInfo from './components/LineInfo'

import { Button, Col, Row, Popup, Picker, IndexBar, IndexAnchor, Cell, Toast, Icon } from 'vant'
import { mapOperation } from '@/utils/mapOperation'
import { getStationOpenStatistics } from '@/api/station'
import { getAllByCityCode } from '@/api/rim'

export default {
  mixins: [mapOperation], // 混入地图操作的方法
  components: {
    LineInfo,
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Popup.name]: Popup,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Picker.name]: Picker

  },
  data () {
    return ({
      bgsround: require('@/assets/platform/巴赫平均律.mp3'),
      bgAudio: null,
      pageType: 1, // 用于JS文件中，标识线路开通历程，2标识线路选中
      spinShow: false,
      svgHtml: '',

      beginPlay: false,
      stationOpenStatistic: [],
      showPlayContent: false,
      currentAssetId: 0, // 当前暂停后的线路ID
      playIndex: -1, // 播放序列

      showCitys: false,
      cityName: '',
      chooseCity: '',
      citys: this.$store.state.main.mapCitys,
      cityGroup: [],

      showLineInfo: false,
      showHistoryDemand: false,
      showMapMarter: false,

      showLines: false,
      lineColumns: [], // 仅用于线路查询的数据格式
      allLines: [], // 全部的地铁线路
      defalutChooseLine: 0
    })
  },
  mounted () {
    this.formatCityData()
    this.initPageData()
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('svgWorkPlatform').style.height = document.documentElement.clientHeight + 'px'
      this.bgAudio = document.getElementById('music1')
    })
  },
  methods: {
    formatCityData () {
      if (this.$route.params.id && this.citys.find(x => x.code === this.$route.params.id)) {
        this.chooseCity = this.$route.params.id
        this.cityName = this.citys.find(x => x.code === this.$route.params.id).name
      } else {
        this.chooseCity = this.citys[this.citys.length - 1].code
        this.cityName = this.citys[this.citys.length - 1].name
      }

      let group = []
      this.citys.forEach(element => {
        if (group.indexOf(element.group) === -1) {
          group.push(element.group)
        }
      })
      this.cityGroup = group.sort()
    },
    initPageData (cityName) {
      this.initMap(cityName)
      this.loadStationOpenData()
    },
    loadStationOpenData () {
      const data = { cityCode: this.chooseCity }

      getStationOpenStatistics(data).then(res => {
        this.stationOpenStatistic = res.sort(function (a, b) {
          return a.openDate > b.openDate ? 1 : -1
        })
      })

      // 获取所有线路， 用于线路查询
      this.lineColumns = []
      getAllByCityCode(data).then(res => {
        this.allLines = res
        this.defalutChooseLine = res.length - 1
        this.lineColumns = res.map(x => x.name)
      })
    },
    handleLineSearch () {
      this.beginPlay = false
      this.showLines = true
    },
    handleCancelLine () {
      this.showLines = false
    },
    handleChooseLine (val, index) {
      this.showLines = false
      // 选择一条线路, 显示此线路的信息描述
      this.playIndex = this.stationOpenStatistic.findIndex(x => x.assetId === this.allLines[index].id)
      this.showPlayContent = true
      this.showHistoryDemand = true

      if (this.$refs.lineInfo) {
        this.$refs.lineInfo.initPageData(this.allLines[index].id)
      } else {
        setTimeout(() => {
          this.$refs.lineInfo.initPageData(this.allLines[index].id)
        }, 1000)
      }
    },
    autoReplayTime () {
      this.playIndex++
      if (this.playIndex === this.stationOpenStatistic.length) {
        this.playIndex = 0
      }

      setTimeout(() => {
        if (this.beginPlay) {
          this.autoReplayTime()
        }
      }, 2000)
    },
    handleShowDemandStations (stationIds) {
      this.showMapMarter = true
      this.loadResourceStations(stationIds)
    },
    handleChangeCity (city) {
      if (city.code !== this.chooseCity) {
        this.chooseCity = city.code
        this.cityName = city.name
        this.playIndex = -1
        this.bgAudio.currentTime = 0 // 设置背景音乐到0秒位置
        this.beginPlay = false
        this.showPlayContent = false
        this.showHistoryDemand = false
        this.initPageData(city.name)
      }
      this.showCitys = false
    },
    handleCloseTitle () {
      if (this.showMapMarter) {
        this.showHistoryDemand = true
        this.showMapMarter = false
        this.$refs.lineInfo.showLineInfo()
      } else if (this.showHistoryDemand) {
        // 关系窗口， 继续播放显示
        this.showPlayContent = true
        this.beginPlay = true
        this.showHistoryDemand = false
        this.autoReplayTime()
      } else {
        this.showPlayContent = false
      }
    },
    handleClickIcon () {
      this.beginPlay = !this.beginPlay
      if (this.beginPlay) {
        this.autoReplayTime()
      } else {
        this.showPlayContent = true
        this.showHistoryDemand = true
        this.showMapMarter = false
        this.$refs.lineInfo.showLineInfo()
        this.currentAssetId = this.stationOpenStatistic[this.playIndex].assetId
        this.$refs.lineInfo.initPageData(this.currentAssetId)
      }
    }
  },
  computed: {
    showTimeContent () { // 显示文本， 地铁开通内容
      const timeInfo = this.stationOpenStatistic[this.playIndex]

      let showAssetName = timeInfo.assetName.substr(timeInfo.assetName.indexOf('铁') + 1)
      let number = ''
      let stationQuantity = ''

      if (this.stationOpenStatistic.filter(x => x.assetId === timeInfo.assetId).length > 1) {
        number = ' ' + timeInfo.issue + '期 '
      }
      stationQuantity = ' 共 ' + timeInfo.stations.split(',').length + '站'
      return showAssetName + number + stationQuantity
    }
  },
  watch: {
    playIndex (val) {
      if (val === -1) { return }
      if (val === 0) { // 地图初始播放是， 全部隐藏线路
        this.grayMapLines([], [])
      }

      // 先锚点线路
      let currentAsset = this.stationOpenStatistic[val]
      let currentAssetStations = currentAsset.stations.split(',')
      let lineOpen = {
        id: currentAsset.assetId,
        centerStationId: currentAssetStations[parseInt(currentAssetStations.length / 2)]
      }
      this.handleMapGetCenter(lineOpen, false)

      // 获取需要显示的线路ID
      let showStationList = []
      let showAssetList = []

      for (let index = 0; index < val + 1; index++) {
        showAssetList.push(this.stationOpenStatistic[index])
        showStationList = showStationList.concat(this.stationOpenStatistic[index].stations.split(','))
      }

      // 延迟1秒点亮线路
      setTimeout(() => {
        this.grayMapLines(showAssetList, showStationList)
      }, 700)
    },
    beginPlay (val) {
      if (val) {
        this.showPlayContent = true
        this.removeElement('metro_marker')
        this.removeElement('metro_text')
        this.bgAudio.play()
      } else {
        this.bgAudio.pause()
      }
    },
    spinShow (val) {
      if (val) {
        Toast.loading({
          message: '地图加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        })
      } else {
        Toast.clear()
      }
    }
  }
}
</script>
